import { Box, Divider, Grid } from "@mui/material";
import Skeleton from "../../../common/skeleton/skeleton";

function OrderSkeleton() {
    return (
        <>
            {[...Array(10)].map((_, index) => (
                <Grid
                    className="orders__order-item"
                    key={index}
                    container
                    item
                    xs={12}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid container item xs={12} md={3.5} columnGap={3} alignItems="center">
                        <Skeleton variant="circular" animation="wave" width={70} height={70} />
                        <Box>
                            <Skeleton variant="text" animation="wave" width={200} height={20} />
                            <Skeleton variant="text" animation="wave" width={150} height={20} />
                        </Box>
                    </Grid>

                    <Grid container item xs={12} md={3.5} display={{ xs: "none", md: "flex" }} justifyContent="center">
                        <Skeleton variant="text" animation="wave" width={300} height={20} />
                    </Grid>

                    <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", md: "flex" } }} />

                    <Grid container item xs={12} md={3.5} display={{ xs: "none", md: "flex" }} justifyContent="center">
                        <Skeleton variant="text" animation="wave" width={280} height={20} />
                    </Grid>
                </Grid>
            ))}
        </>
    )
}

export default OrderSkeleton;